import ExpensesView from './ExpensesView';

export default ExpensesView;
